import React, { useState, useEffect } from "react";
import "./../Styles/Design.css";
import "./../Styles/Designes.css";

import "rc-slider/assets/index.css";

import { useNavigate, useLocation } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";

import { API } from "../../config/api";

import Designes from "../../Client/Pages/Desingnes";
import SellDesigns from "../../Client/Pages/SellDesigns";
import Adsense from "../../Admin/Pages/Adsense";

import HorizontalAds from "../../Admin/Pages/HorizontalAds";

const categories = ["Malti", "Sequience", "Cording", "Chain", "Beads"];
const areaOptions = [125, 250, 300, 400];
const colorOptions = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: "10", value: "10" },
  { label: "11", value: "11" },
  { label: "12", value: "12" },
];

export default function Design() {
  const navigate = useNavigate();
  const location = useLocation();

  /* Data State */
  const [freeDesigns, setFreeDesigns] = useState([]);
  const [paidDesigns, setPaidDesigns] = useState([]);
  const [concepts, setConcepts] = useState([]);
  const [heightRange, setHeightRange] = useState([0, 1000]);
  const [minHeight, setMinHeight] = useState(0);
  const [maxHeight, setMaxHeight] = useState(1000);
  /* Filters State */
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [selectedConcepts, setSelectedConcepts] = useState([]);
  const [search, setSearch] = useState("");
  const [stitchRange, setStitchRange] = useState([0, 500000]);
  const [minInput, setMinInput] = useState(0);
  const [maxInput, setMaxInput] = useState(400000);
  const [colorFilters, setColorFilters] = useState([]);

  const [freeLoading, setFreeLoading] = useState(false);
  const [paidLoading, setPaidLoading] = useState(false);

  const [freeFetched, setFreeFetched] = useState(false);
  const [paidFetched, setPaidFetched] = useState(false);
  /* Pagination */
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(40);

  /* Cart/Wishlist */
  const [wishlistIds, setWishlistIds] = useState([]);
  const [cartIds, setCartIds] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(100000);
  /* Download & Modals */
  const [showAdModal, setShowAdModal] = useState(false);
  const [adTimer, setAdTimer] = useState(5);
  const [pendingDownloadUrl, setPendingDownloadUrl] = useState(null);
  const [downloaded, setDownloaded] = useState({});
  const [activeTab, setActiveTab] = useState(
    location.state?.activeTab || "free",
  );

  useEffect(() => {
    if (location.state?.activeTab) {
      setActiveTab(location.state.activeTab);
    }
  }, [location.state]);

  useEffect(() => {
    AOS.init({ duration: 700, easing: "ease-in-out", once: true, offset: 80 });
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [
    selectedCategories,
    search,
    selectedAreas,
    stitchRange,
    heightRange,
    colorFilters,
    selectedConcepts,
    itemsPerPage,
  ]);
  useEffect(() => {
    setCurrentPage(1);
    setSearch("");
  }, [location.pathname]);

  const fetchConcepts = async () => {
    try {
      const res = await fetch(API.CONCEPT_LIST);
      const data = await res.json();
      if (data.status) setConcepts(data.data);
    } catch (err) {
      console.log(err);
    }
  };
  const fetchSubcategories = async () => {
    try {
      const res = await fetch(API.LIST_SUBCATEGORY);
      const data = await res.json();

      if (data.status) {
        setSubcategories(data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchFreeDesigns = async (showLoading = true) => {
    if (showLoading) {
      setFreeLoading(true);
    }

    try {
      const res = await fetch(API.LIST_ALL_DESIGNS);
      const data = await res.json();

      if (data.status) {
        setFreeDesigns(data.data);
      } else {
        setFreeDesigns([]);
      }
    } catch (err) {
      console.log(err);
      setFreeDesigns([]);
    } finally {
      setFreeFetched(true);

      if (showLoading) {
        setFreeLoading(false);
      }
    }
  };

  const fetchPaidDesigns = async (showLoading = true) => {
    if (showLoading) {
      setPaidLoading(true);
    }

    try {
      const res = await fetch(API.LIST_ALL_DESIGNS_user);
      const data = await res.json();

      if (data.status) {
        setPaidDesigns(data.data);

        const maxHeightValue = Math.max(
          ...data.data.map((d) => Number(d.height) || 0),
          0,
        );

        const maxStitchValue = Math.max(
          ...data.data.map((d) => Number(d.stitch) || 0),
          0,
        );

        const maxPriceValue = Math.max(
          ...data.data.map((d) => Number(d.price) || 0),
          0,
        );

        setHeightRange([0, maxHeightValue]);
        setMinHeight(0);
        setMaxHeight(maxHeightValue);

        setStitchRange([0, maxStitchValue]);
        setMinInput(0);
        setMaxInput(maxStitchValue);

        setPriceRange([0, maxPriceValue]);
        setMinPrice(0);
        setMaxPrice(maxPriceValue);
      } else {
        setPaidDesigns([]);
      }
    } catch (err) {
      console.log(err);
      setPaidDesigns([]);
    } finally {
      setPaidFetched(true);

      if (showLoading) {
        setPaidLoading(false);
      }
    }
  };
  const syncLocalState = () => {
    const loginUser = JSON.parse(sessionStorage.getItem("user"));
    if (!loginUser) return;
    const cart = JSON.parse(localStorage.getItem(`cart_${loginUser.id}`)) || [];
    const wishlist =
      JSON.parse(localStorage.getItem(`wishlist_${loginUser.id}`)) || [];
    setCartIds(cart.filter((i) => i.type === "design").map((i) => i.id));
    setWishlistIds(
      wishlist.filter((i) => i.type === "design").map((i) => i.id),
    );
  };

  const resetFilters = () => {
    const designs = activeTab === "free" ? freeDesigns : paidDesigns;

    const maxStitch =
      designs.length > 0
        ? Math.max(...designs.map((d) => Number(d.stitch) || 0))
        : 0;

    const maxHeight =
      designs.length > 0
        ? Math.max(...designs.map((d) => Number(d.height) || 0))
        : 0;

    const maxPrice =
      designs.length > 0
        ? Math.max(...designs.map((d) => Number(d.price) || 0))
        : 0;

    setSelectedCategories([]);
    setSearch("");
    setSelectedAreas([]);
    setColorFilters([]);
    setSelectedConcepts([]);
    setCurrentPage(1);

    // Stitch
    setStitchRange([0, maxStitch]);
    setMinInput(0);
    setMaxInput(maxStitch);

    // Height
    setHeightRange([0, maxHeight]);
    setMinHeight(0);
    setMaxHeight(maxHeight);

    // Price
    setSelectedSubcategories([]);
    setPriceRange([0, maxPrice]);
    setMinPrice(0);
    setMaxPrice(maxPrice);
  };
  const handleCategoryClick = (cat) => {
    setSelectedAreas([]);
    const designs = activeTab === "free" ? freeDesigns : paidDesigns;

    const maxStitch =
      designs.length > 0
        ? Math.max(...designs.map((d) => Number(d.stitch) || 0))
        : 0;

    setStitchRange([0, maxStitch]);
    setMinInput(0);
    setMaxInput(maxStitch);
    setColorFilters([]);
    setSelectedConcepts([]);
    setSearch("");
    setCurrentPage(1);
    if (cat === "ALL") {
      setSelectedCategories([]);
    } else {
      setSelectedCategories([cat]);
    }
  };

  const toggleArea = (area) => {
    setSelectedAreas((prev) =>
      prev.includes(area) ? prev.filter((a) => a !== area) : [...prev, area],
    );
  };

  const toggleConcept = (id) => {
    setSelectedConcepts((prev) =>
      prev.includes(id) ? prev.filter((c) => c !== id) : [...prev, id],
    );
  };

  const triggerDownload = (file, category, code, id) => {
    const url = `${API.DOWNLOAD}&file=FreeDesigns/${file}`;
    setPendingDownloadUrl({ url, code, id });
    setAdTimer(5);
    setShowAdModal(true);
  };

  useEffect(() => {
    if (!showAdModal || adTimer <= 0) return;
    const interval = setInterval(() => {
      setAdTimer((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, [showAdModal, adTimer]);

  const normalizeCategory = (cat) => cat?.trim().toLowerCase();
  const filteredConcepts =
    selectedCategories.length === 0
      ? concepts
      : concepts.filter((c) => selectedCategories.includes(c.category));

  const groupedConcepts = filteredConcepts.reduce((acc, concept) => {
    const key = normalizeCategory(concept.category);
    if (!acc[key]) acc[key] = [];
    acc[key].push(concept);
    return acc;
  }, {});

  const designs = activeTab === "free" ? freeDesigns : paidDesigns;
  const filteredDesigns = designs.filter((d) => {
    const categoryMatch =
      selectedCategories.length === 0 ||
      selectedCategories.includes(d.category);
    const searchMatch =
      d.design_code?.toLowerCase().includes(search.toLowerCase()) ||
      d.id?.toString().includes(search);
    const areaMatch =
      selectedAreas.length === 0 || selectedAreas.includes(parseInt(d.area));
    const dStitch = parseInt(d.stitch) || 0;
    const stitchMatch = dStitch >= stitchRange[0] && dStitch <= stitchRange[1];

    let colorMatch = true;
    if (colorFilters.length > 0) {
      const cCount = parseInt(d.color) || 0;
      colorMatch = colorFilters.some((filterVal) =>
        filterVal === "4" ? cCount >= 4 : cCount.toString() === filterVal,
      );
    }
    const conceptMatch =
      selectedConcepts.length === 0 ||
      selectedConcepts.some((id) => d.concepts_array?.includes(id));
    const subcategoryMatch =
      activeTab === "free" ||
      selectedSubcategories.length === 0 ||
      selectedSubcategories.includes(Number(d.subcategory_id || d.subcategory));
    const designHeight = Number(d.height) || 0;

    const heightMatch =
      activeTab === "free" ||
      (designHeight >= heightRange[0] && designHeight <= heightRange[1]);
    const designPrice = Number(d.price) || 0;

    const priceMatch =
      activeTab === "free" ||
      (designPrice >= priceRange[0] && designPrice <= priceRange[1]);
    return (
      categoryMatch &&
      searchMatch &&
      areaMatch &&
      stitchMatch &&
      colorMatch &&
      conceptMatch &&
      subcategoryMatch &&
      priceMatch &&
      heightMatch
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentDesigns = filteredDesigns.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const totalPages = Math.ceil(filteredDesigns.length / itemsPerPage);

  const paginate = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleCardClick = (design) => {
    if (activeTab === "free") {
      navigate(`/designe-details/${design.id}`, {
        state: { ...design, fromTab: "free" },
      });
    } else {
      navigate(`/design-details/${design.id}`, {
        state: { ...design, fromTab: "paid" },
      });
    }
  };
  useEffect(() => {
    if (activeTab === "free") {
      fetchFreeDesigns(true);
    } else {
      fetchPaidDesigns(true);
    }
  }, [activeTab]);
  useEffect(() => {
    // Fetch only active tab when page opens
    if (activeTab === "free") {
      fetchFreeDesigns(true);
    } else {
      fetchPaidDesigns(true);
    }

    fetchConcepts();
    fetchSubcategories();
    syncLocalState();
  }, []);
  const addToCart = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) {
      alert("Please Login First");
      return;
    }
    let items = JSON.parse(localStorage.getItem(`cart_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");
    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setCartIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setCartIds((prev) => [...prev, design.id]);
    }
    localStorage.setItem(`cart_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  const addToWishlist = (design) => {
    const user = JSON.parse(sessionStorage.getItem("user"));
    if (!user) return;
    let items = JSON.parse(localStorage.getItem(`wishlist_${user.id}`)) || [];
    const exists = items.find((i) => i.id === design.id && i.type === "design");
    if (exists) {
      items = items.filter((i) => !(i.id === design.id && i.type === "design"));
      setWishlistIds((prev) => prev.filter((id) => id !== design.id));
    } else {
      items.push({ ...design, type: "design" });
      setWishlistIds((prev) => [...prev, design.id]);
    }
    localStorage.setItem(`wishlist_${user.id}`, JSON.stringify(items));
    window.dispatchEvent(new Event("cartUpdated"));
  };

  useEffect(() => {
    if (activeTab === "paid" && paidDesigns.length > 0) {
      resetFilters();
    }

    if (activeTab === "free" && freeDesigns.length > 0) {
      resetFilters();
    }
  }, [activeTab, paidDesigns, freeDesigns]);
  const toggleSubcategory = (id) => {
    id = Number(id);

    setSelectedSubcategories((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };
  const getPagination = () => {
    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
      return pages;
    }

    // Always show first page
    pages.push(1);

    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);

    // Near beginning
    if (currentPage <= 3) {
      start = 2;
      end = 5;
    }

    // Near end
    if (currentPage >= totalPages - 2) {
      start = totalPages - 4;
      end = totalPages - 1;
    }

    if (start > 2) {
      pages.push("...");
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (end < totalPages - 1) {
      pages.push("...");
    }

    // Always show last page
    pages.push(totalPages);

    return pages;
  };

  return (
    <div className="design-page container-fluid py-4">
      <div className="row g-4">
        <div
          className="col-lg-2 order-1"
          data-aos="fade-right"
          data-aos-duration="700"
        >
          <div className="uniq-filter-sidebar shadow-sm p-2 bg-white">
            <div className="d-flex justify-content-between align-items-center mb-4 filter-header-border">
              <h5 className="mb-0 fw-bold text-secondary text-uppercase tracking-wider fs-6">
                Filters
              </h5>
              <button className="btn-uniq-reset" onClick={resetFilters}>
                Clear All
              </button>
            </div>

            {/* Search */}
            <div className="mb-4">
              <label className="form-label-uniq">Search Code</label>
              <input
                className="form-control form-control-uniq"
                placeholder="Type code here..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {activeTab === "paid" && (
              <div className="mb-4">
                <label className="form-label-uniq">Sub Category</label>

                <div className="subcategory-scroll-box">
                  {subcategories.map((sub) => (
                    <button
                      key={sub.id}
                      type="button"
                      className={`subcategory-btn ${
                        selectedSubcategories.includes(Number(sub.id))
                          ? "active"
                          : ""
                      }`}
                      onClick={() => toggleSubcategory(sub.id)}
                    >
                      {sub.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
            {activeTab === "paid" && (
              <div className="mb-4">
                <label className="form-label-uniq">Price Range</label>

                <div className="d-flex gap-2">
                  <input
                    type="text"
                    className="form-control form-control-uniq"
                    value={minPrice}
                    onChange={(e) => {
                      let v = Number(e.target.value);
                      setMinPrice(v);
                      setPriceRange([v, priceRange[1]]);
                    }}
                  />

                  <input
                    type="text"
                    className="form-control form-control-uniq"
                    value={maxPrice}
                    onChange={(e) => {
                      let v = Number(e.target.value);
                      setMaxPrice(v);
                      setPriceRange([priceRange[0], v]);
                    }}
                  />
                </div>
              </div>
            )}
            {/* Area Choices */}
            <div className="mb-4 ps-4">
              <label className="form-label-uniq">Area</label>
              <div className="custom-checkbox-group">
                {areaOptions.map((area) => (
                  <div className="form-check custom-uniq-check" key={area}>
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`area-${area}`}
                      checked={selectedAreas.includes(area)}
                      onChange={() => toggleArea(area)}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`area-${area}`}
                    >
                      {area} mm
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Stitch Input Bounds */}
            <div className="mb-4">
              <label className="form-label-uniq">Stitch Range</label>
              <div className="d-flex gap-2">
                <input
                  type="text"
                  className="form-control form-control-uniq"
                  value={minInput}
                  onChange={(e) => {
                    const v = Number(e.target.value) || 0;
                    setMinInput(v);
                    setStitchRange([v, stitchRange[1]]);
                  }}
                />
                <input
                  type="text"
                  className="form-control form-control-uniq"
                  value={maxInput}
                  onChange={(e) => {
                    const v = Number(e.target.value) || 0;
                    setMaxInput(v);
                    setStitchRange([stitchRange[0], v]);
                  }}
                />
              </div>
            </div>
            {activeTab === "paid" && (
              <div className="mb-4">
                <label className="form-label-uniq">Height Range</label>

                <div className="d-flex gap-2">
                  <input
                    type="text"
                    className="form-control form-control-uniq"
                    placeholder="Min"
                    value={minHeight}
                    onChange={(e) => {
                      const value = Number(e.target.value) || 0;
                      setMinHeight(value);
                      setHeightRange([value, heightRange[1]]);
                    }}
                  />

                  <input
                    type="text"
                    className="form-control form-control-uniq"
                    placeholder="Max"
                    value={maxHeight}
                    onChange={(e) => {
                      const value = Number(e.target.value) || 0;
                      setMaxHeight(value);
                      setHeightRange([heightRange[0], value]);
                    }}
                  />
                </div>
              </div>
            )}
            {/* Colors Options Matrix Grid */}
            <div className="mb-4">
              <label className="form-label-uniq">Colors</label>

              <div className="color-filter-grid">
                {colorOptions.map((opt) => (
                  <button
                    type="button"
                    key={opt.value}
                    className={`color-filter-btn ${
                      colorFilters.includes(opt.value) ? "active" : ""
                    }`}
                    onClick={() => {
                      if (colorFilters.includes(opt.value)) {
                        setColorFilters(
                          colorFilters.filter((c) => c !== opt.value),
                        );
                      } else {
                        setColorFilters([...colorFilters, opt.value]);
                      }
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Concept Checkboxes Context Groups */}
            <div className="mb-4">
              <label className="form-label-uniq mb-2">Concepts</label>
              {categories
                .filter((cat) => groupedConcepts[normalizeCategory(cat)])
                .map((category) => {
                  const key = normalizeCategory(category);
                  return (
                    <div
                      className="mb-3 ps-2 concept-section-border"
                      key={category}
                    >
                      <h6 className="uniq-concept-title">{category}</h6>
                      {groupedConcepts[key].map((concept) => (
                        <div
                          className="form-check custom-uniq-check"
                          key={concept.id}
                        >
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id={`concept-${concept.id}`}
                            checked={selectedConcepts.includes(concept.id)}
                            onChange={() => toggleConcept(concept.id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`concept-${concept.id}`}
                          >
                            {concept.concept_name}
                          </label>
                        </div>
                      ))}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        {/* RIGHT SIDE MAIN DISPLAY - Top on Mobile, Right on Desktop */}
        <div className="col-lg-10 order-2">
          {/* HEADER BAR */}
          <div
            className="d-flex align-items-center flex-wrap gap-3 mb-4 p-3 bg-white shadow-sm rounded-3"
            data-aos="fade-down"
            data-aos-delay="100"
          >
            {/* Tabs */}
            <div className="uniq-tab-container">
              <button
                className={`uniq-tab-btn ${activeTab === "free" ? "active" : ""}`}
                onClick={() => setActiveTab("free")}
              >
                Free Designs
              </button>
              <button
                className={`uniq-tab-btn ${activeTab === "paid" ? "active" : ""}`}
                onClick={() => setActiveTab("paid")}
              >
                Paid Designs
              </button>
            </div>

            {/* Categories */}
            <div className="d-flex flex-wrap gap-2 align-items-center ps-2 dynamic-category-bar">
              <button
                className={`uniq-cat-pill ${selectedCategories.length === 0 ? "active" : ""}`}
                onClick={() => handleCategoryClick("ALL")}
              >
                All Categories
              </button>
              {categories.map((cat) => (
                <button
                  key={cat}
                  className={`uniq-cat-pill ${selectedCategories.includes(cat) ? "active" : ""}`}
                  onClick={() => handleCategoryClick(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>

            {/* Show Dropdown */}
            <div className="ms-auto d-flex align-items-center gap-2 select-uniq-wrapper">
              <select
                className="form-select form-select-sm select-uniq-input"
                value={itemsPerPage}
                onChange={(e) => setItemsPerPage(Number(e.target.value))}
              >
                <option value={20}>20</option>
                <option value={40}>40</option>
                <option value={100}>100</option>
              </select>
            </div>
          </div>

          {/* Grids Component Injector */}

          {/* {activeTab === "paid" ? (
            paidLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary"></div>
                <p className="mt-3">Loading paid designs...</p>
              </div>
            ) : (
              <SellDesigns
                designs={currentDesigns}
                concepts={concepts}
                cartIds={cartIds}
                wishlistIds={wishlistIds}
                handleCardClick={handleCardClick}
                addToCart={addToCart}
                addToWishlist={addToWishlist}
              />
            )
          ) : (
            <Designes
              designs={currentDesigns}
              concepts={concepts}
              downloaded={downloaded}
              cartIds={cartIds}
              wishlistIds={wishlistIds}
              triggerDownload={triggerDownload}
              handleCardClick={handleCardClick}
              addToCart={addToCart}
              addToWishlist={addToWishlist}
            />
          )} */}
          {activeTab === "paid" ? (
            <SellDesigns
              loading={paidLoading}
              designs={currentDesigns}
              concepts={concepts}
              cartIds={cartIds}
              wishlistIds={wishlistIds}
              handleCardClick={handleCardClick}
              addToCart={addToCart}
              addToWishlist={addToWishlist}
            />
          ) : (
            <Designes
              loading={freeLoading}
              designs={currentDesigns}
              concepts={concepts}
              downloaded={downloaded}
              cartIds={cartIds}
              wishlistIds={wishlistIds}
              triggerDownload={triggerDownload}
              handleCardClick={handleCardClick}
              addToCart={addToCart}
              addToWishlist={addToWishlist}
            />
          )}

          {/* PAGINATION */}
          {totalPages > 1 && (
            <div className="d-flex justify-content-center mt-5">
              <ul className="pagination uniq-pagination-wrapper shadow-sm p-1 rounded-pill bg-white">
                <li
                  className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link rounded-pill"
                    onClick={() => paginate(currentPage - 1)}
                  >
                    &lsaquo; Previous
                  </button>
                </li>
                {getPagination().map((page, index) =>
                  page === "..." ? (
                    <li key={`dots-${index}`} className="page-item disabled">
                      <span className="page-link border-0 bg-transparent">
                        ...
                      </span>
                    </li>
                  ) : (
                    <li
                      key={page}
                      className={`page-item ${currentPage === page ? "active" : ""}`}
                    >
                      <button
                        className="page-link rounded-circle"
                        onClick={() => paginate(page)}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li
                  className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                >
                  <button
                    className="page-link rounded-pill"
                    onClick={() => paginate(currentPage + 1)}
                  >
                    Next &rsaquo;
                  </button>
                </li>
              </ul>
            </div>
          )}
          <HorizontalAds />
        </div>

        {/* LEFT SIDE FILTER PANEL - Bottom on Mobile, Left Sticky on Desktop */}
      </div>

      {/* SPONSORED AD TIMER INTERCEPTOR MODAL */}
      {showAdModal && (
        <div className="dlm-overlay" onClick={() => setShowAdModal(false)}>
          <div className="dlm-dialog" onClick={(e) => e.stopPropagation()}>
            <div className="dlm-content">
              {/* Header */}
              <div className="dlm-header">
                <h2 className="dlm-title">Unlocking Your Design</h2>
                <p className="dlm-subtitle">
                  We provide 100% free designs thanks to our sponsors.
                </p>
              </div>

              {/* Sponsored Card */}
              <div className="dlm-ad-card">
                <div className="dlm-ad-badge">SPONSORED AD</div>
                <div className="dlm-ad-body">
                  <h4 className="dlm-ad-brand">Your Ad Space Here</h4>
                  <div className="dlm-ad-placeholder">
                    <Adsense />
                  </div>
                </div>
              </div>

              {/* Dynamic Action Section */}
              <div className="dlm-action-section">
                {adTimer > 0 ? (
                  <div className="dlm-timer-wrapper">
                    <span className="dlm-timer-text">
                      Preparing your file...
                    </span>
                    <div className="dlm-timer-number">{adTimer}s</div>
                  </div>
                ) : (
                  <div className="dlm-ready-area">
                    <p className="dlm-ready-msg">✨ Your file is ready!</p>
                    <a
                      href={pendingDownloadUrl?.url || "#"}
                      className="dlm-btn-download"
                      onClick={(e) => {
                        e.preventDefault();

                        const url = pendingDownloadUrl?.url;
                        const code = pendingDownloadUrl?.code || "design";
                        const id = pendingDownloadUrl?.id;

                        if (!url) return;

                        let ext = "emb";
                        if (url.includes(".zip")) ext = "zip";
                        else if (url.includes(".rar")) ext = "rar";

                        const link = document.createElement("a");
                        link.href = url;
                        link.download = `${code}.${ext}`;

                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        if (id) {
                          setDownloaded((prev) => ({
                            ...prev,
                            [id]: true,
                          }));
                        }

                        setShowAdModal(false);
                      }}
                    >
                      Download Now
                    </a>
                  </div>
                )}
              </div>

              {/* Secondary Dismiss Action */}
              <button
                type="button"
                className="dlm-btn-dismiss"
                onClick={() => setShowAdModal(false)}
              >
                Maybe later
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
